import React, { useState, useEffect } from "react";
import styles from "../Plans/Plans.module.css";
import plans_Type_Data from "../../Data/RO-landing.json";
import { FcNext, FcPrevious } from "react-icons/fc";
const Plans = () => {
  // filtering amc plans  data and storing in avariable using useEffect Hook....
  const [plans, setPlans] = useState({});

  useEffect(() => {
    let plans_Data = plans_Type_Data.map((elem) =>
      elem.cards.filter((sT) => sT.cardType == "amc")
    );
    setPlans(plans_Data);
  }, []);

  return (
    <div className={styles.container}>
      <div> {<FcPrevious id={styles.prev_next} />}</div>
      <div className={styles.container2}>
        {plans[0]?.map((data, index) => {
          return (
            <div className={styles.card}>
              <>
                <img src={data.cardBanner} alt="" />
                <h3>{data.title}</h3>
                <div className={styles.covers}>
                  {data.covers.map((dt) => (
                    <p>{dt}</p>
                  ))}
                </div>
                <div className={styles.card_Inner}>
                  <h4> Rs. {data.price} /-</h4>
                  <p>*T&C Apply</p>
                  <button>Book Now</button>
                </div>
              </>
            </div>
          );
        })}
      </div>
      <div>
        <FcNext id={styles.prev_next} />
      </div>
    </div>
  );
};

export default Plans;
